import { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { Megaphone } from 'lucide-react';

function SendCampaignNode({ data, selected }: NodeProps) {
  const config = (data.config as Record<string, unknown>) ?? {};
  const segmentName = (config.segmentName as string) || '';
  const templateName = (config.templateName as string) || (config.templateId as string) || '';

  return (
    <div
      className={`w-52 rounded-xl bg-white shadow-sm border border-zinc-200 border-l-4 border-l-cyan-500 ${
        selected ? 'ring-2 ring-emerald-400' : ''
      }`}
    >
      <Handle type="target" position={Position.Top} className="!bg-cyan-500" />
      <div className="flex items-center gap-2 px-3 py-2 border-b border-zinc-100">
        <Megaphone size={14} className="text-cyan-500 shrink-0" />
        <span className="text-xs font-semibold text-zinc-700 uppercase tracking-wide">
          Send Campaign
        </span>
      </div>
      <div className="px-3 py-2 space-y-1">
        <div>
          <p className="text-xs text-zinc-500">Segment</p>
          <p className="text-xs text-zinc-800 font-medium truncate">
            {segmentName || <span className="italic text-zinc-400">Not set</span>}
          </p>
        </div>
        <div>
          <p className="text-xs text-zinc-500">Template</p>
          <p className="text-xs text-zinc-800 font-medium truncate">
            {templateName || <span className="italic text-zinc-400">Not set</span>}
          </p>
        </div>
      </div>
      <Handle type="source" position={Position.Bottom} className="!bg-cyan-500" />
    </div>
  );
}

export default memo(SendCampaignNode);
